// import React, { useState } from 'react';
import styles from './Footer.module.css';
// import Swal from 'sweetalert2';
import { Link,useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  // const [form, setForm] = useState({ name: '', email: '', message: '' });



  return (
    <main className={`${styles.specialFoot} w-full py-10`}>
      <section className={`max-w-[1920px] mx-auto flex items-center flex-wrap lg:justify-between ph:justify-center min-h-[150px] xl:px-[200px] lg:px-[100px] md:px-[30px] ph:px-10 ph:py-5 md:py-0`}>
        <img src="/images/Horo_Logo_white.svg" alt="logo" className='pr-5 my-8' onClick={() => navigate('/')} />
        <div className='w-[70%] flex items-center justify-around text-main-background flex-wrap gap-5 md:mt-0 ph:mt-5'>
          <Link to="/termsConditions" className="">ข้อตกลงและเงื่อนไข</Link>
          <Link to="/privacyPolicy" className="">นโยบายความเป็นส่วนตัว</Link>
          <p>สำหรับแอดมิน</p>
          <p>สำหรับอาจารย์</p>
        </div>
     
        <article className='text-white'>
          บริษัท เอไอ เทคโนเวชั่น จำกัด <br />
          ที่อยู่ : 18/124 หมู่ที่ 8 ตำบลเสารงหิน อำเภอบางใหญ่ จ.นนนทบุรี 1140<br />
          อีเมล: support@ai-technovation.com<br />
          เว็บไชต์: <a href=" https://thaidaily365.com" target="_blank">https://thaidaily365.com/</a><br />
          เบอร์โทรศัพท์: 088-924-1954
        </article>
      </section>
    </main>

  );
};

export default Footer;